import PageContainer from '@/common/components/PageContainer'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { PermissionKeys } from '@/modules/manage-member/mappers'
import InviteFriendListing from '@/modules/promotion/components/InviteFriend/components/InviteFriendListing'

function InviteFriendPage() {
	return (
		<PageContainer>
			<InviteFriendListing />
		</PageContainer>
	)
}

const GuardedInviteFriendPage = withUserPermission(InviteFriendPage, {
	permissionType: PermissionType.Read,
	permissionKey: [PermissionKeys.MANAGE_INVITE],
})

export default GuardedInviteFriendPage
